import { findKeyInObj } from '../../utils/objects';

export function replaceStrings(localeData, obj) {
  const strings = Object.keys(obj)
    .filter(k => typeof obj[k] === 'string' && k !== 'value')
    .reduce((acc, cv) => {
      const val = findKeyInObj(localeData, obj[cv]);
      if (val) {
        acc[cv] = val;
      }
      return acc;
    }, {});

  return {
    ...obj,
    ...strings,
  };
}



// WEBPACK FOOTER //
// ./src/app/ui/config/replace-strings.js